
export const initTicketsController = function() {

	let bagdeElement = null;

	const init = (buttonElement) => {

		const allowNotifications = true;
		const Controller = TicketProveedoresController.init({ currentUser, allowNotifications, onSnapshotActiveNotificationsLength })

		bagdeElement = buttonElement.children[0]
		buttonElement.onclick = () => TicketProveedoresController.show();

		return null;
	}

	const onSnapshotActiveNotificationsLength = (activeNotifications) => {
		bagdeElement.innerHTML = activeNotifications;
		// bagdeElement.style.display = activeNotifications ? 'block' : 'none';
	}

	return init;
}();





export const initprofileController = function () {

	const data = {};

	const init = (buttonElement) => {

		const profileContainer = document.querySelector('.profile-container');
		const [ displayElement ] = profileContainer.children;
		const [ titleElement, bodyElement ] = displayElement.children;

		addInfoHTML({ bodyElement });
		addCloseFunction({ profileContainer, titleElement });

		buttonElement.onclick = () => show({ profileContainer });
	}

	const addCloseFunction = ({ profileContainer, titleElement }) => {
		const [ titleSpan, closeButton ] = titleElement.children;
		closeButton.onclick = () => {
			profileContainer.style.display = 'none';
		}
	}

	const addInfoHTML = ({ bodyElement }) => {

		bodyElement.innerHTML = `

			<div class="profile-container__display__body__info-container">

				<div class="profile-container__display__body__img">
					<img src="${currentUser.imagen_usuario}" />
				</div>

				<div class="profile-container__display__body__name">
					${currentUser.nombre}
					<br />
					<a
						href="../02_01_perfil/" target="_blank"
						style="color: white;margin-top: 10px;display: inline-block;padding: 5px 10px;background: #78b30f;font-size: 1rem;"
						class="btn-mkk"
					>
						<span class="fas fa-edit"></span>
						Editar Perfil
					</a>
				</div>

			</div>

			<div class="profile-container__display__body__quick_access-title"> Accesos Rápidos </div>

			<div class="profile-container__display__body__quick_access-container"> </div>
		`;
	}


	const show = async ({ profileContainer }) => {

		profileContainer.style.display = 'flex';

		if (data.quick_access) return;

		const cardsElement = profileContainer.querySelector('.profile-container__display__body__quick_access-container');
		const quickAccessRef = db.collection("usuarios").doc(currentUser.id).collection('preferencias').doc('quick_access');
		const quickAccessDoc = await quickAccessRef.get();

		data.quick_access = Object.values(quickAccessDoc.data() || {})

		const quick_access_html = data.quick_access.reduce((acc, obj) => acc + `
			<a class="profile-container__display__body__quick_access-container__item" title="Ingresar" href="${obj.url}" target="_blank" style="color: ${ obj.color }; background-color: ${ obj.backgroundColor };" >
				${obj.icon} ${obj.name}
			</a>
		`, '');

		cardsElement.innerHTML = quick_access_html;
	}






	return init;
}();











export const initNotificacionesController = function () {

	const data = {
		isFirstTime : true
	};

	const init = async (buttton) => {

		const notificationsContainer = document.querySelector('.notifications-container');
		const [ displayElement ] = notificationsContainer.children;
		const [ titleElement, bodyElement ] = displayElement.children;

		addCloseFunction({ notificationsContainer, titleElement });

		buttton.onclick = () => show({ notificationsContainer, bodyElement });

		const [ bagdeElement ] = buttton.children;

		const [ notificationsCollection, userByEmailDoc ] = await Promise.all([
			db.collection('usuarios_por_email').doc(currentUser.email).collection('notificaciones').orderBy("createAt", "desc").limit(25).get(),
			// db.collection('usuarios_por_email').doc(currentUser.email).get()
		]).catch(GlobalThings.Error)

		data.notifications = GlobalThings.getArrayCollection(notificationsCollection);
		// data.user_by_email = userByEmailDoc.data() || {}
		data.bagdeElement = bagdeElement

		const active_notifications = data.notifications.filter(notf => notf.activo === true);

		bagdeElement.innerHTML = active_notifications.length

		if (active_notifications.length) {
			bagdeElement.style.display = 'block';
		}else{
			bagdeElement.style.display = 'none';
		}
	}

	const addCloseFunction = ({ notificationsContainer, titleElement }) => {
		const [ titleSpan, closeButton ] = titleElement.children;
		closeButton.onclick = () => {
			notificationsContainer.style.display = 'none';
		}
	}

	const show = ({ notificationsContainer, bodyElement }) => {

		data.bagdeElement.innerHTML = 0
		data.bagdeElement.style.display = 'none'

		if (data.isFirstTime) {
			data.isFirstTime = false

			data.notifications.forEach(notf => {
				db.collection('usuarios_por_email').doc(currentUser.email).collection('notificaciones').doc(notf.id).update({
					activo : false
				})
			})
		}


		notificationsContainer.style.display = 'flex';
		bodyElement.innerHTML = data.notifications.reduce((acc, notf) => {

			const createAt = notf.createAt.toDate();

			return acc + `
				<div class="notifications-container__display__body__item">
					<div class="notifications-container__display__body__item__header">
						<span> ${GlobalThings.date_format_DMY_01(createAt)} </span>
						<span> ${GlobalThings.date_format_HMS(createAt)} </span>
					</div>

					<div class="notifications-container__display__body__item__body">
						${notf.mensaje}
					</div>
				</div>
			`
		}, '');
	}


	return init
}();












export const initHelpController = function () {

	const settings = {
		modal : {
			type 			: 'Small-06',
			id				: 'Modal_support_home',
			Header 			: `
				<div class="Title">Ayuda</div>
				<div class="Btn-group">
					<i class="fas fa-times Btn-02" onclick="Components.closeModal('Modal_support_home');"></i>
				</div>
			`,
			Body 			: `

				<p>
					Hola, te damos la bienvenida a <b>metroKUBIKO</b>, recuerda que este menú lo obtendrás siempre haciendo click en el ícono de ayuda.

					<img
						style="border-radius: 5px; margin: 5px auto 0px; height: 55px; display: block;"
						src="https://firebasestorage.googleapis.com/v0/b/copres-firebase.appspot.com/o/CoPres%2Fdesarrollo%2FMen%C3%BA%20de%20Ayuda.jpg?alt=media&token=80139126-41e1-48cc-b1cf-e39c9614626c"
					/>
				</p>

				<p>
					Empieza creando un <b>Presupuesto de Obra</b> en dos sencillos pasos:
				</p>

				<div class="info_section">
					<section class="title"> Paso 1: Agregar actividades </section>
					<section class="video">

						<div class="youtube_icon">
							<svg viewBox="0 0 28.5 20" preserveAspectRatio="xMidYMid meet" focusable="false" class="style-scope yt-icon" style="pointer-events: none;display: block;width: 80px;opacity: .1;"><g viewBox="0 0 28.5 20" preserveAspectRatio="xMidYMid meet" class="style-scope yt-icon"><g class="style-scope yt-icon"><path d="M27.9727 3.12324C27.6435 1.89323 26.6768 0.926623 25.4468 0.597366C23.2197 2.24288e-07 14.285 0 14.285 0C14.285 0 5.35042 2.24288e-07 3.12323 0.597366C1.89323 0.926623 0.926623 1.89323 0.597366 3.12324C2.24288e-07 5.35042 0 10 0 10C0 10 2.24288e-07 14.6496 0.597366 16.8768C0.926623 18.1068 1.89323 19.0734 3.12323 19.4026C5.35042 20 14.285 20 14.285 20C14.285 20 23.2197 20 25.4468 19.4026C26.6768 19.0734 27.6435 18.1068 27.9727 16.8768C28.5701 14.6496 28.5701 10 28.5701 10C28.5701 10 28.5677 5.35042 27.9727 3.12324Z" fill="#FF0000" class="style-scope yt-icon"></path><path d="M11.4253 14.2854L18.8477 10.0004L11.4253 5.71533V14.2854Z" fill="white" class="style-scope yt-icon"></path></g></g></svg>
						</div>

						<iframe
							allowfullscreen frameborder="0"
							title="Paso 1  Agregar Actividades"
							src="https://www.youtube.com/embed/KRfHCQiKn6o"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						>
						</iframe>

					</section>
					<button class="btn-mkk"> Decargar PDF </button>
				</div>

				<div class="info_section">
					<section class="title"> Paso 2: Personalizar Actividades </section>
					<section class="video">

						<div class="youtube_icon">
							<svg viewBox="0 0 28.5 20" preserveAspectRatio="xMidYMid meet" focusable="false" class="style-scope yt-icon" style="pointer-events: none;display: block;width: 80px;opacity: .1;"><g viewBox="0 0 28.5 20" preserveAspectRatio="xMidYMid meet" class="style-scope yt-icon"><g class="style-scope yt-icon"><path d="M27.9727 3.12324C27.6435 1.89323 26.6768 0.926623 25.4468 0.597366C23.2197 2.24288e-07 14.285 0 14.285 0C14.285 0 5.35042 2.24288e-07 3.12323 0.597366C1.89323 0.926623 0.926623 1.89323 0.597366 3.12324C2.24288e-07 5.35042 0 10 0 10C0 10 2.24288e-07 14.6496 0.597366 16.8768C0.926623 18.1068 1.89323 19.0734 3.12323 19.4026C5.35042 20 14.285 20 14.285 20C14.285 20 23.2197 20 25.4468 19.4026C26.6768 19.0734 27.6435 18.1068 27.9727 16.8768C28.5701 14.6496 28.5701 10 28.5701 10C28.5701 10 28.5677 5.35042 27.9727 3.12324Z" fill="#FF0000" class="style-scope yt-icon"></path><path d="M11.4253 14.2854L18.8477 10.0004L11.4253 5.71533V14.2854Z" fill="white" class="style-scope yt-icon"></path></g></g></svg>
						</div>

						<iframe
							allowfullscreen frameborder="0"
							title="Paso 2  Personalizar Actividades"
							src="https://www.youtube.com/embed/xk35OYS0_BI"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						>
						</iframe>

					</section>
					<button class="btn-mkk"> Decargar PDF </button>
				</div>

			`,

			/*
				<div class="SelectorRow">
					<div class="Title">  Soporte de METRO kubiko  </div>
					<div class="BtnController">
						<a
							title="Crear Ticket"
							class="btn-mkk btn-ingresar add-ticket"
							onclick="
								Components.closeModal('Modal_support_home');
							"
						>
							Crear Ticket
						</a>
						<a
							title="Ir a la consola"
							class="btn-mkk btn-ingresar"
							target="_blank"
							href="http://plataforma.metrokubiko.com/05_01_soporte/00_soporte.html"
							onclick="
								Components.closeModal('Modal_support_home');
							"
						>
							Ir a la consola
						</a>
					</div>
				</div>
				<div class="SelectorRow">
					<div class="Title">  Canal de YouTube  </div>
					<div class="BtnController">
						<a
							title="Ir"
							class="btn-mkk btn-pdf fas fa-play"
							target="_blank"
							href="https://www.youtube.com/channel/UCxSVaVo8_XZ6HA3oWsOkzYA"
							onclick="
								Components.closeModal('Modal_support_home');
							"
						>
						</a>
					</div>
				</div>
			*/
		}
	}



	const init = (button) => {
		button.onclick = () => show();
	}

	const show = () => {

		const Modal = new Components.Modal(settings.modal);
		Modal.create()

		// const btnAddTicket = Modal.Body.querySelector('.add-ticket');
		// btnAddTicket.onclick = () => addTicket();
	}

	init.show = show

	let proyectos = null;

	const addTicket = async () => {

		if (!proyectos) {
			PreLoader.init();
			const proyectosCollection = await db.collection('cuentas').doc(currentUser.id_cuenta).collection('proyectos').where('activo','==',true).get();
			proyectos = GlobalThings.getArrayCollection(proyectosCollection);
			PreLoader.finish();
		}

		GLOBALES.crear_caso_soporte({
			proyectos,
			user : currentUser,
		});
	}



	return init
}();

window.helpController = initHelpController

export const signOut = (button) => {
	button.onclick = async () => {

		const response = await GlobalThings.confirm({
			content : 'Estas seguro de cerrar sesión?',
			cancel : 'Cancelar',
			accept : 'Aceptar',
		});

		if (!response) return;

		await firebase.auth().signOut().catch(GlobalThings.Error);

		window.location.href = '../index.html';
	}
}


export const addContextMenu_More = (button) => {
	Components.DropDown({
		element : button,
		items : [
			{
				text : 'Descargar PWA',
				id : 'pwa',
			},
		],
		onclick : (item) => {
			if (item.id === 'pwa') {
				window.location.href = '../pwa/';
				return;
			}
		}
	});
}





export async function initChatController (btnChat) {

	btnChat.style.display = ''

	const [ createModalController, createNotificationsController ] = await Promise.all([
		(await eval(`import('../../17_chat_controller/modal_controller/min.js')`)).default,
		(await eval(`import('../../17_chat_controller/notifications_controller/min.js')`)).default,
	])

	let modalController = null

	const chatNotificationsController = await createNotificationsController({
		currentUser,
		target : btnChat,
		onShow () {

			if (modalController) {
				modalController.show()
				return
			}

			modalController = createModalController({
				currentUser
			})

			modalController.show()
		}
	})
}



// Cuenta Suspendida ------------------------------------------------------------------------------------------------------------

	export const determinarCuentaSuspendida = (docDataCuenta) => {

		docDataCuenta.fecha_próximo_pago = docDataCuenta.fecha_próximo_pago.toDate()
		docDataCuenta.timeToPay = docDataCuenta.fecha_próximo_pago.getTime() - new Date().getTime()
		docDataCuenta.timeToPay = parseInt(parseFloatEN(docDataCuenta.timeToPay / (1000 * 3600 * 24)))

		if (docDataCuenta.suspendida) {
			// modalCuentaSuspendida(docDataCuenta);

			return {
				status: 'suspended',
				message: 'Cuenta Suspendida',
			}
		}

		if (docDataCuenta.timeToPay < 0 || docDataCuenta.timeToPay >= 15) {
			return {
				status: 'active',
			}
		}

		return {
			status: 'for_suspending',
			message: (docDataCuenta.timeToPay === 1 ? 'Falta 1 dia' : 'Faltan ' + docDataCuenta.timeToPay + ' dias') + ' para finalizar su suscripción.',
		}
	}

	// const modalCuentaSuspendida = (docDataCuenta) => {

	// 	const closeButton = document.querySelector('.cuenta_suspendida-modal__display__header__btn-close');
	// 	const CuentaSuspendidaModal = document.querySelector('.cuenta_suspendida-modal');
	// 	const span = CuentaSuspendidaModal.querySelector('.message-date');

	// 	span.innerHTML = GlobalThings.date_format_DMY_01(docDataCuenta.fecha_próximo_pago)
	// 	CuentaSuspendidaModal.style.display = '';

	// 	closeButton.onclick = () => {
	// 		CuentaSuspendidaModal.style.display = 'none';
	// 	}
	// }


	// const showMessage = (type, message) => {

	// 	const MessageElement = document.querySelector('.main-container__message');
	// 	const Elements = document.querySelectorAll('[home-message]');

	// 	MessageElement.classList.add(type);
	// 	MessageElement.innerHTML = message + ' <a style="color: inherit; text-decoration: underline;" target="_blank" href="https://www.metrokubiko.com/planes">Actualizar Cuenta</a>';

	// 	Elements.forEach(Element => Element.style.display = '');
	// }

// Cuenta Suspendida ------------------------------------------------------------------------------------------------------------



